import { h, Component } from 'preact'
import tdlib, { TdEvent } from '../../utils/tdlib'
import { withStore } from '../../providers/store'
import { getStatus } from '../../utils/status'
import ChatPreview from '../ChatPreview'
import { getParamFromUrl } from '../../utils/url'
import { QUERY_PARAMS } from '../../constants/query'
import { iStore } from '../../types/store'
import s from './ChatList.css'

interface iProps {
  store: iStore
}

interface iState {
  chatIds: number[]
}

class ChatList extends Component<iProps, iState> {
  state = {
    chatIds: []
  }

  componentDidMount () {
    tdlib
      .send({
        '@type': 'getChats',
        offset_order: '9223372036854775807',
        offset_chat_id: 0,
        limit: 15
      })
      .then((event: TdEvent) => {
        this.setState({
          chatIds: event.chat_ids
        })
      })
  }

  render () {
    const { store } = this.props
    const activeChat = Number(getParamFromUrl(QUERY_PARAMS.CHAT))

    const { chatIds }: iState = this.state

    return (
      <div className={s.ChatList}>
        {chatIds.map(chatId => {
          const isOnline = getStatus(
            store.statuses[chatId],
            store.users![chatId]
          )

          return (
            <ChatPreview
              key={chatId}
              chatId={chatId}
              isActive={activeChat === chatId}
              chat={store.chats[chatId]}
              isOnline={isOnline}
              lastMessage={store.lastMessages[chatId]}
              pin={store.pins[chatId] || {}}
              unread={store.unread[chatId]}
              chatAction={store.chatActions[chatId]}
            />
          )
        })}
      </div>
    )
  }
}

export default withStore(ChatList)
